import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import API from '../lib/api';

const MACHINES = [
  { id: 'digital_paper', label: 'Digital Paper (Konica / Xerox)' },
  { id: 'flex_large_format', label: 'Flex / Large Format' },
  { id: 'vinyl_cutter', label: 'Vinyl Cutter' },
  { id: 'sublimation', label: 'Sublimation' },
  { id: 'canopy_assembly', label: 'Canopy Assembly' },
];

const PartnerOnboarding = () => {
  const nav = useNavigate();
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({
    shop_name: '', address: '', service_pincodes: '', machine_types: [],
    machine_brand: '', bank_account: '', bank_ifsc: '', upi_id: '', gst: '',
    allowed_categories: [], accept_tnc: false,
  });
  useEffect(() => { API.get('/categories').then(r => setCats(r.data)); }, []);
  const toggle = (key, val) => setForm(f => ({ ...f, [key]: f[key].includes(val) ? f[key].filter(x => x !== val) : [...f[key], val] }));
  const submit = async (e) => {
    e.preventDefault();
    if (!form.accept_tnc) { toast.error('Accept the agreement'); return; }
    try {
      await API.post('/partners/onboarding', {
        ...form,
        service_pincodes: form.service_pincodes.split(',').map(s => s.trim()).filter(Boolean),
      });
      toast.success('Submitted for admin approval');
      nav('/partner');
    } catch (e) { toast.error('Failed'); }
  };
  return (
    <div className="p-6">
      <div className="reg-mark">
        <div className="text-[10px] tracking-[0.32em] uppercase font-bold" style={{ color: 'var(--pk-primary)' }}>— Onboarding</div>
        <h1 className="font-display text-[26px] mt-2 leading-tight">Set up your press.</h1>
      </div>
      <form onSubmit={submit} className="mt-5 space-y-3">
        <div><label className="pk-label">Shop name</label><input required className="pk-input" value={form.shop_name} onChange={e => setForm({ ...form, shop_name: e.target.value })} data-testid="po-shop" /></div>
        <div><label className="pk-label">Address</label><textarea rows={2} className="pk-textarea" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} required data-testid="po-addr"/></div>
        <div><label className="pk-label">Service pincodes (comma separated)</label><input className="pk-input font-mono" value={form.service_pincodes} onChange={e => setForm({ ...form, service_pincodes: e.target.value })} data-testid="po-pins" /></div>
        <div>
          <label className="pk-label">Machine types</label>
          <div className="flex flex-wrap gap-2">
            {MACHINES.map(m => <button type="button" key={m.id} onClick={() => toggle('machine_types', m.id)} className={`pk-chip ${form.machine_types.includes(m.id) ? 'active' : ''}`} data-testid={`po-m-${m.id}`}>{m.label}</button>)}
          </div>
        </div>
        <div><label className="pk-label">Machine brand</label><input className="pk-input" value={form.machine_brand} onChange={e => setForm({ ...form, machine_brand: e.target.value })} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="pk-label">Account #</label><input className="pk-input font-mono" value={form.bank_account} onChange={e => setForm({ ...form, bank_account: e.target.value })}/></div>
          <div><label className="pk-label">IFSC</label><input className="pk-input font-mono" value={form.bank_ifsc} onChange={e => setForm({ ...form, bank_ifsc: e.target.value })}/></div>
        </div>
        <div><label className="pk-label">UPI ID</label><input className="pk-input font-mono" value={form.upi_id} onChange={e => setForm({ ...form, upi_id: e.target.value })} data-testid="po-upi"/></div>
        <div><label className="pk-label">GST (optional)</label><input className="pk-input font-mono" value={form.gst} onChange={e => setForm({ ...form, gst: e.target.value })}/></div>
        <div>
          <label className="pk-label">Allowed categories</label>
          <div className="flex flex-wrap gap-2">
            {cats.map(c => <button type="button" key={c.category_id} onClick={() => toggle('allowed_categories', c.category_id)} className={`pk-chip ${form.allowed_categories.includes(c.category_id) ? 'active' : ''}`}>{c.name}</button>)}
          </div>
        </div>
        <label className="flex items-start gap-2 pk-card p-3">
          <input type="checkbox" checked={form.accept_tnc} onChange={e => setForm({ ...form, accept_tnc: e.target.checked })} data-testid="po-agree"/>
          <div className="text-[12px]">I accept the PrintingKit partner agreement (no commission, direct settlement, quality warranty).</div>
        </label>
        <button className="pk-btn w-full" data-testid="po-submit">Submit for review</button>
      </form>
    </div>
  );
};

export default PartnerOnboarding;
